module.exports = __webpack_public_path__ + "img/55.245eb78c.png";